import { Slugs } from 'common/urls/Slugs';
import { Routes } from 'src/shared/Routes';
import { match, P } from 'ts-pattern';
import { getShefMenuUrl } from '../design-system/DishFirst/DishModal/utils';
import { getSluggedPath } from './RouteUtilities';

interface GetReferralUrlParams {
  code: string;
  shefId?: string;
  foodItemSlug?: string;
  orderUuid?: string;
  userId?: string;
  useNewReferralValues?: boolean;
}

export const getReferralUrl = (params: GetReferralUrlParams, injectedWindow?: any) => {
  // Handle new referral values case - use shef menu URL instead of referral URL
  if (params.useNewReferralValues && params.shefId) {
    const shefMenuPath = getShefMenuUrl(params.shefId);
    return `${(injectedWindow ?? window).location.origin}${shefMenuPath}`;
  }

  const path = match(params)
    .with({ shefId: P.string, foodItemSlug: P.string }, ({ code, shefId, foodItemSlug }) =>
      getSluggedPath(Routes.CONSUMER_REFER_FOOD_ITEM, [
        { slug: Slugs.ID, value: code },
        { slug: Slugs.SHEF_ID, value: shefId },
        { slug: Slugs.NAME, value: foodItemSlug },
      ])
    )
    .with({ shefId: P.string }, ({ code, shefId }) =>
      getSluggedPath(Routes.CONSUMER_REFER_SHEF, [
        { slug: Slugs.ID, value: code },
        { slug: Slugs.SHEF_ID, value: shefId },
      ])
    )
    .with({ orderUuid: P.string, userId: P.string }, ({ orderUuid, userId }) =>
      getSluggedPath(Routes.CONSUMER_REFER_ORDER, [
        { slug: Slugs.ID, value: userId },
        { slug: Slugs.ORDER, value: orderUuid },
      ])
    )
    .otherwise(({ code }) => getSluggedPath(Routes.CONSUMER_REFER, [{ slug: Slugs.ID, value: code }]));

  return `${(injectedWindow ?? window).location.origin}${path}`;
};
